import React, { useState ,useEffect } from "react";
import useForm from "./useForm";
import { Link } from "react-router-dom";
import { useNavigate  } from "react-router-dom";
import Grid from '@mui/material/Grid'
import { withStyles } from "@material-ui/styles";
import config from '../../config';
import {Box,List,Typography,useTheme,Button,Tab,Tabs} from "@mui/material";
import { SnackbarProvider, useSnackbar } from 'notistack';
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import validate from "./LoginFormValidationRules";


import UndoIcon from '@mui/icons-material/Undo';
const TagScreen = ({activeIndexn,handleChangesn}) => {
const [activeIndex, setActiveIndex] = useState(activeIndexn);
const { values, errors, tagsScreen  , tagsScreenPreValue, handleChange, handleSubmit , handleChangelast, handleSubmitLast  } = useForm(
    
    validate
    );
const handleChanges = (_, activeIndex) => setActiveIndex(activeIndex);
const currentUserNameVars = ReactSession.get('kdsName');
const [selectedItems, setSelectedItems] = useState(ReactSession.get('selectedtags'));
const [tagsScreenValue, setTagsScreenValue] = useState(ReactSession.get('alltags'));
const [uniqueItems, setUniqueItems] = useState([]);
const [nextScreen, setNextScreen] = useState(false);
const [checkedValues, setCheckedValues] = useState([]);
const { enqueueSnackbar } = useSnackbar();




useEffect(() => {
if(activeIndexn === 0){
  console.log("test00");
}if(activeIndexn === 1){
  console.log("test11");
}
  
}, [activeIndexn])
const onClickSubmit = async(data) => {
  
  const array = selectedItems;
  ReactSession.set("selectedtags", selectedItems);
  const result = array.join(',');
  const url = config().apiUrl + "kitchen-device-tag-update";
  const getToken = ReactSession.get("authToken")
  axios.defaults.headers.common['Authorization'] = `Bearer ${getToken}`;
    // Set headers
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken}`
    };
  try {
    const response = await axios.post(url, {
      tags :result
   },{headers});

   ReactSession.set("currentTags", result);
   enqueueSnackbar('Device tag updated successfully!!', {variant: 'success',anchorOrigin: {
    vertical: 'top',
    horizontal: 'right'
  }},);

  
 } catch (error) {
  if (error.response && error.response.status === 401) {
    // Handle 401 Unauthorized error
    ReactSession.set("currentTags", null);
    ReactSession.set("kdsName", null);
    ReactSession.set("authToken", null);
    ReactSession.set("userData", null);
    ReactSession.set("kdsName", null);
    ReactSession.set("userSetting", null);
    ReactSession.set("alltags", null);
    window.location.reload(); // Reload the page
  } else {
    // Handle other errors
    console.error(error);
  }
 }
};



 
    const handleCheckboxChange = (event) => {
        try {
          // Access the target element from the event
          const target = event.target;
          const { value, checked } = event.target;
          if (checked) {
            setCheckedValues((prevValues) => [...prevValues, value]);
          } else {
            setCheckedValues((prevValues) => prevValues.filter((val) => val !== value));
          }
          // Check if the target element exists and has a value
          if (target && target.value !== undefined) {
            const { value, checked } = target;
    
            // If the checkbox is checked, add the item to the selectedItems array
            if (checked) {
              setSelectedItems(prevItems => [...prevItems, value]);
              // Add the value to the uniqueItems array if it's not already present
              if (!uniqueItems.includes(value)) {
                setUniqueItems(prevItems => [...prevItems, value]);
              }
            } else {
              // If the checkbox is unchecked, remove the item from the selectedItems array
              setSelectedItems(prevItems => prevItems.filter(item => item !== value));
              // Remove the value from the uniqueItems array
              setUniqueItems(prevItems => prevItems.filter(item => item !== value));
            }
          } else {
            console.error("Target element or its value is undefined");
          }
        } catch (error) {
          if (error.response && error.response.status === 401) {
            // Handle 401 Unauthorized error
            window.location.reload(); // Reload the page
          } else {
            // Handle other errors
            console.error(error);
          }
        }
       
    };
    return (
      <div style={{ display: "flex", position: 'relative' }}>
        
  
        <div className="flex items-center justify-center h-screen form-container outer tabone">
              <div className="form-form">
                  <div className="form-form-wrap">
                      <div className="form-container">
                          <div className="form-content">
                              <div className="avatar avatar-xl">
                              
                              </div>
                              
                              <div className=" card-1">
                                  <div className="top">
                                  <div className="hiddenCB">
                                      <h3>Select Tags</h3>
                                     
                                       <div className="text-left form">
                                      
                                      {tagsScreenValue &&  tagsScreenValue.map((item, index) => {
                                          const matchedItem = tagsScreenPreValue.find(current => current == item.id)  ;
                                        
                                      return (
                                        <div className="mb-2 field-wrapper input checkdiv grey400">
                                         
                                        <input type="checkbox" className="le-checkbox"  value={item.id} onChange={handleCheckboxChange} checked={selectedItems.includes(matchedItem?matchedItem:item.id.toString())} id={`cb${index + 1}`} /><label className="labelCls taptwolable" for={`cb${index + 1}`}>{item.name}</label>
                                        </div>
                                      )
                                      })}
                                      <form className="text-left">
                                       
                                        <button
                                          type="button"
                                          onClick={() =>  onClickSubmit()}
                                          className="button btn nextbutton tagselectionbuttonunderscreen btn-primary login-form-button ant-btn is-block is-info is-fullwidth"
                                        >
                                          Submit
                                        </button>

                                       

                                      
                                    </form>      
                                      
                                      </div>
                  
                                        </div>
                                      </div>
                              
                                  </div>
                              


                          </div>

                      </div>

                  </div>
              </div>
          </div>
      </div>
    );
  };
  
  const VerticalTabs = withStyles((theme) => ({
    flexContainer: {
      flexDirection: "column"
    },
    indicator: {
      display: "none"
    }
  }))(Tabs);
  
  const MyTab = withStyles((theme) => ({
    root: {
      backgroundColor: "#ccc",
      // borderRadius: theme.shape.borderRadius
    },
    wrapper: {
      backgroundColor: "#ddd",
      // padding: theme.spacing(2),
      // borderRadius: theme.shape.borderRadius
    },
    selected: {
      color: "tomato",
      borderBottom: "2px solid tomato"
    }
  }))(Tab);
  
  const TabContainer = (props) => {
    return (
      <Typography component="div" style={{ padding: 24 }}>
        {props.children}
      </Typography>
    );
  };
  

export default TagScreen;
